import React from "react";
import aside_img from "../../assets/icons/home_about.svg";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ambulance from "../../assets/animations/ambulance.json";
import doctor from "../../assets/animations/personal-branding.json"
import report from "../../assets/animations/checkup.json"
import Lottie from "lottie-react";
const HomeAbout = () => {
  return (
    <div className="relative ">
      <div className="bottom-0 right-0 absolute">
        <img src={aside_img} alt="" />
      </div>
      <div
        data-aos="fade-up"
        className="xl:w-[1280px] grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 md:ps-0 ps-10  lg:gap-0 gap-8  mx-auto xl:pt-28 lg:pt-20 md:pt-14 pt-10"
      >
        <div className="flex flex-row gap-5 md:justify-center justify-start border-r border-dashed  items-center border-[#B87333]">
          <div className="w-20 h-20">
            <Lottie animationData={ambulance} loop={true} />
          </div>
          <div>
            <p className="text-lg font-semibold text-matcha">
              Emervency Services
            </p>
            <p className="text-base font-medium text-[#1d9e75]">
              24/7 Emergency services
            </p>
          </div>
        </div>
        <div className="flex flex-row gap-5 md:justify-center justify-start border-r border-dashed  items-center border-[#B87333]">
          <div className="w-20 h-20">
            <Lottie animationData={doctor} loop={true} />
          </div>
          <div>
            <p className="text-lg font-semibold text-matcha">
              Qulified Doctors
            </p>
            <p className="text-base font-medium text-[#1d9e75]">
              Best Doctors Collection
            </p>
          </div>
        </div>
        <div className="flex flex-row gap-5 md:justify-center justify-start items-center ">
           <div className="w-[72px] h-[72px]">
            <Lottie animationData={report} loop={true} />
          </div>
          <div>
            <p className="text-lg font-semibold text-matcha">
              Get Online Report
            </p>
            <p className="text-base font-medium text-[#1d9e75]">
              We mail your Report
            </p>
          </div>
        </div>
      </div>
      <div
        data-aos="fade-up"
        className="xl:w-[1280px] flex  lg:flex-row flex-col lg:gap-0 gap-8 w-11/12  mx-auto lg:py-[120px] md:py-24 xl:px-10 px-0 2xl:px-0 py-12"
      >
        <div className=" relative flex flex-col overflow-hidden p-6 bg-almond lg:w-1/3 rounded-xl ">
          <h2 className="text-2xl font-bold text-matcha text-center tracking-wider border-b  border-dashed border-[#B87333] pb-4">
            Dr. Hemanth Makineni
          </h2>
          <h3 className="text-lg font-medium text-matcha text-center tracking-wider border-b border-dashed border-[#B87333] py-4">
            MS (General Surgery)
            <br />
            M.Ch (Surgical Oncology)
          </h3>
          <h3 className="text-lg font-medium text-matcha text-center tracking-wider border-b border-dashed border-[#B87333] py-4 flex flex-col">
            <span>Monday - Friday</span>
            <span className="font-semibold">9:00 PM - 06:00 PM</span>
          </h3>
          <h3 className="text-lg font-medium text-matcha text-center tracking-wider  py-4 flex flex-col">
            <span>Saturday - Sunday</span>
            <span className="font-semibold">9:00 PM - 06:00 PM</span>
          </h3>
          <Link
            to="/contact-me"
            className="bg-matcha py-3 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-xl hover:bg-transparent hover:text-matcha duration-200 transition"
          >
            Book An Appointment <ArrowRight strokeWidth={1} />
          </Link>
        </div>
        <div className="lg:w-2/3 xl:pe-10 xl:ps-16 lg:ps-8 flex flex-col xl:gap-3 gap-2">
          <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 w-32">
            About Me
          </span>
          <h3 className="text-2xl font-bold text-matcha ">
            My Journey in Medicine
          </h3>
          <p className="text-base text-matcha font-normal pb-1">
            When it comes to expert cancer surgery in Guntur, Dr. Hemanth
            Makineni stands as one of the most trusted and accomplished names in
            the field of Surgical Oncology. As the Director and Consultant
            Surgical Oncologist at Arka Hospital & Research Institute, Dr.
            Makineni has dedicated his career to providing advanced,
            compassionate, and patient-centered cancer care.
          </p>
          <p className="text-base text-matcha font-normal pb-1">
            With over 10 years of experience and a record of 5,000+ successful
            cancer surgeries, he has transformed countless lives through
            precision, expertise, and empathy.
          </p>

          <p className="text-base text-matcha font-normal pb-2">
            With over a decade of experience in Surgical Oncology, Dr. Hemanth
            Makineni has successfully performed more than 5,000 complex and
            routine cancer surgeries.
          </p>
          <Link
            to="/about-me"
            className="bg-matcha py-3 w-44 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-xl hover:bg-transparent hover:text-matcha duration-200 transition"
          >
            Read More <ArrowRight strokeWidth={1} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
